/**
 *
 * Link
 *
 */
import clsx from 'clsx';
import React, { memo } from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { makeThemeStyle } from 'styles/makeThemeStyle';

interface StyleProps {
  overrideLinkStyle?: string;
}
interface LinkProps extends RouterLinkProps, StyleProps {
  underline?: boolean;
}

const useStyles = makeThemeStyle(theme => ({
  link: {
    textDecoration: 'none',
  },
}));

export const Link = memo((props: React.PropsWithChildren<LinkProps>) => {
  const { underline = true, children, overrideLinkStyle, ...rest } = props;
  const classes = useStyles();
  return (
    <RouterLink
      {...rest}
      className={clsx([overrideLinkStyle, { [classes.link]: !underline }])}
    >
      {children}
    </RouterLink>
  );
});
